import React from 'react';
import './CircularProgress.css';

interface CircularProgressProps {
  score: number;
  label: string;
  size?: number;
  strokeWidth?: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({ 
  score, 
  label, 
  size = 60, 
  strokeWidth = 6 
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  const getScoreColor = (score: number): string => {
    if (score >= 80) return '#10b981'; // green
    if (score >= 60) return '#f59e0b'; // amber
    return '#ef4444'; // red
  };

  const getScoreBackgroundColor = (score: number): string => {
    if (score >= 80) return '#dcfce7'; // light green
    if (score >= 60) return '#fef3c7'; // light amber
    return '#fee2e2'; // light red
  };

  const scoreColor = getScoreColor(score);
  const backgroundColor = getScoreBackgroundColor(score);

  return (
    <div className="circular-progress-container">
      <div className="circular-progress-wrapper">
        <svg
          width={size}
          height={size}
          className="circular-progress-svg"
        >
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#e5e7eb"
            strokeWidth={strokeWidth}
            fill="transparent"
            className="circular-progress-bg"
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={scoreColor}
            strokeWidth={strokeWidth}
            fill="transparent"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            className="circular-progress-fill"
            style={{
              transform: 'rotate(-90deg)',
              transformOrigin: '50% 50%',
              transition: 'stroke-dashoffset 0.5s ease-in-out'
            }}
          />
        </svg>
        <div 
          className="circular-progress-content"
          style={{ backgroundColor }}
        >
          <span className="circular-progress-score">{score}</span>
        </div>
      </div>
      <span className="circular-progress-label">{label}</span>
    </div>
  );
};

export default CircularProgress;
